// Comprehensive Syllabus and Topic Bank for YKS, LGS, and Maarif Modeli (9, 10, 11, 12, Mezun)
export const STUDY_CURRICULUM_DATA = {
  TYT: {
    'TYT Türkçe': [
      'Sözcükte Anlam',
      'Cümlede Anlam',
      'Paragrafta Anlam',
      'Ses Bilgisi',
      'Yazım Kuralları',
      'Noktalama İşaretleri',
      'Sözcükte Yapı',
      'İsimler (Adlar)',
      'Sıfatlar (Ön Adlar)',
      'Zamirler (Adıllar)',
      'Zarflar (Belirteç)',
      'Edat, Bağlaç, Ünlem',
      'Fiiler (Eylemler)',
      'Ek Fiil',
      'Fiilimsi',
      'Fiilde Çatı',
      'Cümle Ögeleri',
      'Cümle Türleri',
      'Anlatım Bozuklukları',
    ],
    'TYT Matematik': [
      'Sayı Kümeleri ve Çeşitleri',
      'Bölme-Bölünebilme',
      'Ebob-Ekok',
      'Rasyonel Sayılar',
      'Bir Bilinmeyenli Eşitsizlikler',
      'Mutlak Değer',
      'Üslü İfadeler',
      'Köklü İfadeler',
      'Çarpanlara Ayırma',
      'Oran – Orantı',
      'Denklem Çözme',
      'Sayı – Kesir Problemleri',
      'Yaş Problemleri',
      'Hareket Problemleri',
      'Karışım Problemleri',
      'Yüzde-Faiz Problemleri',
      'Tablo-Grafik Problemleri',
      'Rutin Olmayan Problemler',
      'Veri',
      'Mantık',
      'Kümeler',
      'Permütasyon',
      'Kombinasyon',
      'Pascal Üçgeni ve Binom Açılımı',
      'Olasılık',
    ],
    'TYT Geometri': [
      'Doğruda Açılar',
      'Üçgende Açılar',
      'Açı-Kenar Bağıntıları',
      'Eşlik',
      'Benzerlik',
      'Açıortay',
      'Kenarortay',
      'İkizkenar-Eşkenar Üçgen',
      'Dik Üçgen',
      'Üçgende Alan',
      'Çokgenler',
      'Dörtgenler',
      'Yamuk',
      'Paralelkenar',
      'Eşkenar Dörtgen',
      'Dikdörtgen',
      'Kare',
      'Deltoid',
      'Noktanın ve Doğrunun Analitiği',
      'Çemberde Açı ve Uzunluk',
      'Dairenin Çevresi ve Alanı',
      'Dik Prizma',
      'Dik Piramit',
    ],
    'TYT Fizik': [
      'Fizik Bilimine Giriş',
      'Madde ve Özkütle',
      'Dayanıklılık, Adezyon, Kohezyon',
      'Düzgün Doğrusal Hareket',
      'Newton’ın Hareket Yasaları',
      'İş, Enerji ve Güç',
      'Isı ve Sıcaklık',
      'Genleşme',
      'Basınç',
      'Kaldırma Kuvveti',
      'Elektrostatik',
      'Elektrik Akımı ve Devreler',
      'Mıknatıs, Akım ve Manyetik Alan',
      'Aydınlanma ve Gölge',
      'Aynalar',
      'Işığın Kırılması ve Renk',
      'Mercekler',
      'Dalgalar',
    ],
    'TYT Kimya': [
      'Kimya Bilimi',
      'Atom ve Periyodik Sistem',
      'Kimyasal Türler Arası Etkileşimler',
      'Maddenin Hâlleri',
      'Doğa ve Kimya',
      'Kimyanın Temel Kanunları',
      'Mol Kavramı',
      'Kimyasal Tepkime Denklemleri',
      'Kimyasal Hesaplamalar',
      'Karışımlar',
      'Karışımların Ayrılması',
      'Asitler, Bazlar, Tuzlar',
      'Kimya Her Yerde',
    ],
    'TYT Biyoloji': [
      'Biyoloji Bilimi',
      'Temel Bileşenler',
      'Hücrenin Yapısı',
      'Hücre Zarından Madde Alışverişi',
      'Sitoplazma ve Çekirdek',
      'Canlıların Sınıflandırılması',
      'Hücre Bölünmeleri',
      'Üreme Çeşitleri',
      'Kalıtım',
      'Ekosistem Ekolojisi',
    ],
    'TYT Tarih': [
      'Tarih Bilimine Giriş',
      'İlk Çağ Medeniyetleri',
      'İslamiyet Öncesi Türk Devletleri',
      'İslam Tarihi ve Uygarlığı',
      'Türk-İslam Devletleri',
      'Türkiye Tarihi',
      'Beylikten Devlete',
      'Dünya Gücü Osmanlı Devleti',
      'Arayış Yılları',
      'Yeniçağ Avrupası',
      'Yüzyılda Değişim ve Diplomasi',
      'Yakınçağ Avrupası',
      'En Uzun Yüzyıl',
      'Osmanlı Kültür ve Medeniyeti',
      '1881’den 1919’a Mustafa Kemal',
      'Yüzyıl Başlarında Dünya',
      'I. Dünya Savaşı',
      'I. TBMM Dönemi',
      'Kurtuluş Savaşında Cepheler',
      'Türk İnkılabı',
      'Atatürkçülük ve Atatürk İlkeleri',
      'Atatürk Dönemi Türk Dış Politikası',
    ],
    'TYT Coğrafya': [
      'Doğa ve İnsan',
      'Dünya’nın Şekil ve Hareketleri',
      'Coğrafi Konum',
      'Harita Bilgisi',
      'Atmosfer ve İklim',
      'Sıcaklık',
      'Basınç ve Rüzgarlar',
      'Nemlilik ve Yağış',
      'İklim Tipleri ve Bitki Örtüsü',
      'Türkiye’nin İklimi',
      'İç Kuvvetler',
      'Dış Kuvvetler',
      'Su Kaynakları',
      'Topraklar',
      'Bitkiler',
      'Nüfus',
      'Göç',
      'Yerleşmeler',
      'Bölgeler ve Ülkeler',
      'Doğal Afetler',
    ],
    'TYT Din Kültürü': [
      'İnanç',
      'İbadet',
      'Ahlâk ve Değerler',
      'Din, Kültür ve Medeniyet',
      'Hz. Muhammed (SAV.)',
      'Vahiy ve Akıl',
      'İslam ve Bilim / Anadolu’da İslam',
      'Kur’an’da Bazı Kavramlar',
      'İslam Düşüncesinde Tasavvufi Yorumlar',
      'Güncel Dini Meseleler',
      'Dinler',
    ],
    'TYT Felsefe': [
      'Felsefeyi Tanıma',
      'Felsefe ile Düşünme',
      'Varlık Felsefesi',
      'Bilgi Felsefesi',
      'Bilim Felsefesi',
      'Ahlak Felsefesi',
      'Din Felsefesi',
      'Siyaset Felsefesi',
      'Sanat Felsefesi',
    ],
  },

  AYT_SAYISAL: {
    'AYT Matematik': [
      'Fonksiyonlar',
      'Polinomlar',
      '2. Dereceden Denklemler',
      'Karmaşık Sayılar',
      'Parabol',
      'Eşitsizlikler',
      'Permütasyon – Kombinasyon',
      'Binom ve Olasılık',
      'Logaritma',
      'Diziler',
      'Trigonometri',
      'Limit ve Süreklilik',
      'Türev Alma Kuralları',
      'Türev Uygulamaları',
      'Belirsiz İntegral',
      'Belirli İntegral',
      'İntegralle Alan Hesabı',
    ],
    'AYT Geometri': [
      'Doğruda Açılar',
      'Üçgende Açılar',
      'Açı-Kenar Bağıntıları',
      'Eşlik – Benzerlik',
      'Açıortay – Kenarortay',
      'İkizkenar-Eşkenar Üçgen',
      'Dik Üçgen',
      'Üçgende Alan',
      'Çokgenler',
      'Yamuk',
      'Paralelkenar',
      'Eşkenar Dörtgen',
      'Dikdörtgen',
      'Kare – Deltoid',
      'Noktanın Analitiği ve Doğrunun Analitiği',
      'Dönüşüm Geometrisi',
      'Çemberde Açı ve Uzunluk',
      'Dairenin Çevresi ve Alanı',
      'Dik Prizma',
      'Dik Piramit',
      'Silindir-Koni-Küre',
      'Çemberin Analitiği',
    ],
    'AYT Fizik': [
      'Vektörler',
      'Bağıl Hareket',
      'Newton’ın Hareket Yasaları',
      'Sabit İvmeli Hareket',
      'Atışlar',
      'Enerji ve Hareket',
      'İtme ve Çizgisel Momentum',
      'Tork-Denge-Ağırlık Merkezi',
      'Basit Makineler',
      'Elektriksel Kuvvet, Potansiyel ve İş',
      'Paralel Levhalar ve Sığa',
      'Manyetizma ve Elektromanyetik İndükleme',
      'Alternatif Akım ve Transformatörler',
      'Çembersel Hareket',
      'Genel Çekim',
      'Açısal Momentum',
      'Basit Harmonik Hareket',
      'Dalga Mekaniği',
      'Dalgalarda Kırınım ve Girişim',
      'Işık Teorileri',
      'Elektromanyetik Dalgalar (EMD)',
      'Fotoelektrik ve Compton',
      'Atom Modelleri',
      'Büyük Patlama ve Radyoaktivite',
      'Modern Fizik',
      'Modern Fiziğin Teknolojideki Uygulamaları',
    ],
    'AYT Kimya': [
      'Kuantum Sayıları',
      'Elektron Dizilimi',
      'Periyodik Özellik',
      'Gazlar',
      'Çözeltilerde Derişim',
      'Koligatif Özellikler',
      'Çözünürlük',
      'Kimyasal Tepkimelerde Enerji',
      'Kimyasal Tepkimelerde Hız',
      'Kimyasal Denge',
      'Asit-Baz Dengesi',
      'Çözünürlük Dengesi (KÇÇ)',
      'Redoks',
      'Piller',
      'Elektroliz',
      'Karbon Kimyasına Giriş',
      'Hidrokarbonlar',
      'Alkoller ve Eterler',
      'Karbonil Bileşikleri',
      'Karboksilik Asitler ve Esterler',
      'Enerji Kaynakları ve Bilimsel Gelişmeler',
    ],
    'AYT Biyoloji': [
      'Sinir Sistemi',
      'Endokrin Sistem',
      'Duyu Organları',
      'Destek ve Hareket Sistemi',
      'Sindirim Sistemi',
      'Dolaşım ve Bağışıklık Sistemi',
      'Solunum Sistemi',
      'Boşaltım Sistemi',
      'Üreme Sistemi ve Embriyonik Gelişim',
      'Komünite ve Popülasyon Ekolojisi',
      'Genetik Şifre-Protein Sentezi',
      'Fotosentez – Kemosentez',
      'Hücresel Solunum',
      'Bitki Biyolojisi',
      'Canlılar ve Çevre',
    ],
  },

  AYT_ESIT_AGIRLIK: {
    'AYT Matematik': [
      'Fonksiyonlar',
      'Polinomlar',
      '2. Dereceden Denklemler',
      'Karmaşık Sayılar',
      'Parabol',
      'Eşitsizlikler',
      'Permütasyon – Kombinasyon',
      'Binom ve Olasılık',
      'Logaritma',
      'Diziler',
      'Trigonometri',
      'Limit ve Süreklilik',
      'Türev Alma Kuralları',
      'Türev Uygulamaları',
      'Belirsiz İntegral',
      'Belirli İntegral',
      'İntegralle Alan Hesabı',
    ],
    'AYT Geometri': [
      'Doğruda Açılar',
      'Üçgende Açılar',
      'Açı-Kenar Bağıntıları',
      'Eşlik – Benzerlik',
      'Açıortay – Kenarortay',
      'İkizkenar-Eşkenar Üçgen',
      'Dik Üçgen',
      'Üçgende Alan',
      'Çokgenler',
      'Yamuk',
      'Paralelkenar',
      'Eşkenar Dörtgen',
      'Dikdörtgen',
      'Kare – Deltoid',
      'Noktanın Analitiği ve Doğrunun Analitiği',
      'Dönüşüm Geometrisi',
      'Çemberde Açı ve Uzunluk',
      'Dairenin Çevresi ve Alanı',
      'Dik Prizma',
      'Dik Piramit',
      'Silindir-Koni-Küre',
      'Çemberin Analitiği',
    ],
    'AYT Edebiyat': [
      'Anlam Bilgisi (Sözcükte, Cümlede ve Paragrafta Anlam)',
      'Edebî Bilgiler',
      'Destan Dönemi (İslamiyet Öncesi) Türk Edebiyatı',
      'İslami Devir Türk Edebiyatı (İlk Ürünler)',
      'Divan Edebiyatı',
      'Halk Edebiyatı',
      'Edebî Akımlar',
      'Tanzimat Edebiyatı',
      'Servetifünun ve Fecriati Edebiyatı',
      'Millî Edebiyat',
      'Cumhuriyet Şiiri',
      'Cumhuriyet Romanı',
      'Cumhuriyet Dönemi',
      'Dünya Edebiyatı',
      'Çağdaş Türk Edebiyatı',
      'Eser Özetleri',
    ],
    'AYT Coğrafya': [
      'Şehirlerin Fonksiyonları',
      'Türkiye’de Nüfus ve Yerleşme',
      'Ekonomik Faaliyetler',
      'Türkiye’de Ekonomik Faaliyetler',
      'Nüfus',
      'Uluslararası Ulaşım Hatları',
      'Bölgeler ve Ülkeler',
      'Çevre ve İnsan',
      'Doğal Afetler',
    ],
    'AYT Tarih': [
      'Tarihin Araştırma Yöntemi',
      'İlk Türk Devletleri',
      'İslam Tarihi',
      'Osmanlı Yükselme Dönemi',
      'Osmanlı Kültür ve Medeniyet',
      'Atatürk’ün Eğitim Hayatı',
      'Kurtuluş Savaşı Hazırlık',
      'Kurtuluş Savaşı',
      'Atatürk İlkeleri',
    ],
  },

  LGS: {
    'Türkçe': [
      'Cümlede Anlam',
      'Sözcükte Anlam',
      'Paragraf',
      'Noktalama İşaretleri',
      'Yazım Kuralları',
      'Fiilimsiler',
      'Cümlenin Ögeleri',
      'Cümle Vurgusu',
      'Fiilde Çatı',
      'Yazı Türleri (Edebi Türler)',
      'Anlatım Bozuklukları',
      'Cümle Çeşitleri',
      'Söz Sanatları',
    ],
    'Matematik': [
      'Çarpanlar ve Katlar',
      'Ebob Ekok ve Aralarında Asal',
      'Üslü İfadeler Tam Sayıların Kuvvetleri / Üslü İfadelerde Çarpma Bölme',
      'Ondalık Gösterimlerin Çözümlemesi',
      '10\'un Tam Sayı Kuvvetleri ve Bilimsel Gösterim',
      'Kareköklü İfadeler / Çarpma-Bölme / Toplama-Çıkarma',
      'Veri Analizi',
      'Basit Olayların Olasılığı',
      'Cebirsel İfadelerde Çarpma İşlemi',
      'Özdeşlikler',
      'Cebirsel İfadelerde Çarpanlara Ayırma',
      'Birinci Dereceden Bir Bilinmeyen Denklem',
      'Koordinat Sistemi',
      'Doğrusal Denklem Grafik Çizimi',
      'Doğrusal İlişki',
      'Eğim',
      'Eşitsizlikler',
      'Üçgenin Yardımcı Elemanları ve Açı Kenar Bağıntıları',
      'Üçgen Çizimi',
      'Pisagor Bağıntısı',
      'Eşlik - Benzerlik',
      'Öteleme - Yansıma',
      'Prizmalarda Alan - Hacim',
      'Silindirde Alan - Hacim',
      'Piramitlerde Alan - Hacim',
      'Dik Konide Alan - Hacim',
    ],
    'Fen Bilgisi': [
      'Mevsimlerin Oluşumu',
      'İklim ve Hava Hareketleri',
      'DNA ve Genetik Kod',
      'Canlılar ve Yaşam / DNA\'da Eşleşme',
      'Kalıtım',
      'Mutasyon ve Modifikasyon',
      'Adaptasyon (Çevreye Uyum)',
      'Biyoteknoloji',
      'Basınç / Katı Basıncı',
      'Sıvı ve Gaz Basıncı',
      'Madde ve Endüstri / Madde ve Doğası',
      'Periyodik Sistem',
      'Fiziksel ve Kimyasal Değişimler',
      'Kimyasal Tepkimeler',
      'Asitler ve Bazlar',
      'Maddenin Isı ile Etkileşimi',
      'Türkiye’de Kimya Endüstrisi',
      'Basit Makineler',
      'Birleşik Makineler',
      'Enerji Dönüşümleri ve Çevre Bilimi',
      'Besin Zinciri ve Enerji Akışı',
      'Enerji Dönüşümleri',
      'Madde Döngüleri ve Çevre Sorunları',
      'Sürdürülebilir Kalkınma',
      'Elektrik Yükleri ve Elektrik Enerjisi',
      'Elektrik Yükleri ve Elektriklenme',
      'Elektrik Yüklü Cisimler / Elektrik Enerjisinin Dönüşümü',
    ],
    'T.C. İnkılap Tarihi': [
      'Avrupa\'daki Gelişmeler',
      'Osmanlı Devleti Dağılma Dönemi Islahatları',
      'Mustafa Kemal\'in Hayatı',
      'XX. Yüzyıl Başlarında Osmanlı Devleti',
      'I. Dünya Savaşı',
      'Milli Mücadele Hazırlık Dönemi',
      'Kurtuluş Savaşı',
      'Atatürk İlke ve İnkılapları',
      'Çok Partili Hayata Geçiş Denemeleri',
      'T.C. Dış Politikası',
      'M. Kemal\'in Ölümü, 2. Dünya Savaşı ve Türkiye',
    ],
    'İngilizce': [
      'Friendship / Arkadaşlık',
      'Teen Life / Gençlerin Yaşamı',
      'In the Kitchen / Mutfakta',
      'On the Phone / Telefonda',
      'The Internet / İnternet',
      'Adventures / Maceralar',
      'Tourism / Turizm',
      'Chores / Ev İşleri',
      'Science / Bilim',
      'Natural Forces / Doğal Kuvvetler',
    ],
    'Din Kültürü': [
      'Kader ve Evrendeki Yasalar',
      'Allah Her Şeyi Bir Ölçüye Göre Yaratmıştır',
      'İnsanın Özgürlüğü ve Sorumluluğu',
      'İnsanın Çabası: Emek ve Rızık',
      'İnsan İradesi ve Kader',
      'Allah’a Güvenmek',
      'Dünya Hayatının Sonu: Ecel ve Ömür',
      'İnsanın Paylaşma ve Yardımlaşma İhtiyacı (Tevekkül)',
      'Hac ve Kurban İbadeti',
      'Zekat',
      'İslam’ın Paylaşma ve Yardımlaşmaya Verdiği Önem',
      'İslam Dinine Göre Kötü Davranışlar',
      'Hz. Muhammed’in (S.A.V) Hayatından Örnek Davranışlar',
      'Kur’an’da Akıl ve Bilgi Davranışları',
    ],
  },

  SINIF_11_SAYISAL: {
    'Matematik': [
      'İki Nicel Değişkenli Veriler',
      'Başkaları Tarafından Oluşturulan İki Nicel Değişkenler',
      'Dörtgenlerin Özellikleri',
      'Özel Dörtgenler Arasındaki İlişkiler',
      'Çokgenlerin Sınıflandırılması',
      'Dışbükey Çokgenlerin Özellikleri',
      'Çokgenlerle İlgili Problemler',
      'Trigonometrik Fonksiyonlar ve Nitel Özellikleri',
      'Trigonometrik Fonksiyonlarla İfade Edilebilen Denklemler',
      'Üstel Fonksiyonlar ve Nitel Özellikleri',
      'Üstel Fonksiyonların Ters Fonksiyonları',
      'Logaritmik Fonksiyonlar ve Nitel Özellikleri',
      'Üstel ve Logaritmik Fonksiyonlarla İfade Edilebilen Denklem ve Eşitsizlikler',
      'Fonksiyonların Bileşkesi',
      'Fonksiyonlarda Dört İşlem',
    ],
    'Fizik': [
      'Serbest Düşme',
      'İki Boyutta Sabit İvmeli Hareket',
      'Newton Hareket Yasaları',
      'Sürtünme Kuvveti',
      'Limit Hız',
      'Çembersel Hareket',
      'Elektriksel Kuvvet ve Elektriksel Alan',
      'Manyetik Alan ve Manyetik Kuvvet',
      'İndüksiyon Akımı',
      'Transformatörler',
      'Işık Şiddeti, Işık Akısı ve Aydınlanma',
      'Düzlem ve Küresel Aynalar',
      'Kırılma',
      'Görünür Derinlik',
      'Fiber Optik ve Prizmalar',
      'Mercekler',
    ],
    'Kimya': [
      'Enerji (Kimyasal Tepkimelerde Enerji)',
      'Kimyasal Tepkimelerde Hız',
      'Kimyasal Denge',
      'Asit Baz Çözeltilerinde Denge',
      'Çözünürlük Dengesi (KÇÇ)',
      'Nanoteknoloji ve Sürdürülebilirlik',
    ],
    'Biyoloji': [
      'Canlılık ve Tepki',
      'Bitkilerde Tepki',
      'Hayvanlarda Tepki',
      'Uyartıya Mekanik Tepki',
      'Bağışıklık',
      'Homeostazi ve Canlılar İçin Önemi',
      'Endokrin Sistemi Homeostazi İşlevi',
      'Dolaşım Sistemi ve Homeostazi / Solunum Sistemi ve Homeostazi',
      'Boşaltım Sistemi Homeostazi',
      'Homeostazinin Sağlanmasında Sistemlerin Eş Güdümlü Çalışması',
    ],
    'Türk Dili ve Edebiyatı': [
      'Geleneksel Türk Tiyatrosu',
      'Fiilimsi',
      'Mektup',
      'Hikaye',
      'Fiil - Fiilde Çatı',
      'Orhun Abideleri ve Ortak Türk Dünyası',
      'Roman',
      'Cümlenin Öğeleri',
      'Biyografi (Yaşam Öyküsü)',
      'Tiyatro',
      'Cümle Türleri',
      'Küçürek Hikaye - Belgesel',
    ],
  },

  SINIF_11_EA: {
    'Matematik': [
      'İki Nicel Değişkenli Veriler',
      'Başkaları Tarafından Oluşturulan İki Nicel Değişkenler',
      'Dörtgenlerin Özellikleri',
      'Özel Dörtgenler Arasındaki İlişkiler',
      'Çokgenlerin Sınıflandırılması',
      'Dışbükey Çokgenlerin Özellikleri',
      'Çokgenlerle İlgili Problemler',
      'Trigonometrik Fonksiyonlar ve Nitel Özellikleri',
      'Trigonometrik Fonksiyonlarla İfade Edilebilen Denklemler',
      'Üstel Fonksiyonlar ve Nitel Özellikleri',
      'Üstel Fonksiyonların Ters Fonksiyonları',
      'Logaritmik Fonksiyonlar ve Nitel Özellikleri',
      'Üstel ve Logaritmik Fonksiyonlarla İfade Edilebilen Denklem ve Eşitsizlikler',
      'Fonksiyonların Bileşkesi',
      'Fonksiyonlarda Dört İşlem',
    ],
    'Türk Dili ve Edebiyatı': [
      'Geleneksel Türk Tiyatrosu',
      'Fiilimsi',
      'Mektup',
      'Hikaye',
      'Fiil - Fiilde Çatı',
      'Orhun Abideleri ve Ortak Türk Dünyası',
      'Roman',
      'Cümlenin Öğeleri',
      'Biyografi (Yaşam Öyküsü)',
      'Tiyatro',
      'Cümle Türleri',
      'Küçürek Hikaye - Belgesel',
    ],
    'Tarih': [
      'Osmanlı Devleti’nin 1683-1789 Yılları Arasındaki Siyasi ve Askerî Mücadeleleri',
      'Lale Devri’nin Devlet ve Toplum Hayatına Etkileri',
      '1755 Lizbon ve 1766 İstanbul Depremlerinin Etkileri',
      'Sanayi Devrimi’nin Meydana Getirdiği Siyasi, Sosyal ve Ekonomik Değişim',
      'Fransız İhtilali’nin Devlet ve Toplum Hayatında Meydana Getirdiği Değişim',
      '1789-1908 Yılları Arasında Osmanlı Devleti’nde Meydana Gelen Siyasi, Askerî ve İdari Gelişmeler',
      '1789-1908 Yılları Arasında Osmanlı Devleti’nde Bilim, Sanat ve Teknolojik Gelişmeler',
      'Osmanlı Devleti’nde Sanayileşme Çabaları',
      '1908-1918 Yılları Arasında Osmanlı Devleti’nde Meydana Gelen Siyasi ve Askerî Gelişmeler',
      '1908-1918 Yılları Arasında Gerçekleşen Kitlesel Göç ve Salgınlar',
      'Osmanlı Devleti’nin İnsanlık Tarihine Katkıları',
    ],
    'Coğrafya': [
      'Mekânsal Sorunlar Karşısında Coğrafya Bilimi',
      'Web Tabanlı CBS Uygulamaları',
      'Su Kaynakları',
      'Türkiye’deki Su Kaynaklarının Etkileri',
      'Yerleşmelerin Mekânsal Organizasyonları',
      'Yerleşmelerin Etki Alanları',
      'Tarımsal Faaliyetler ve Gıda Güvencesi',
      'Tarım Uygulamalarında Sürdürülebilirlik',
      'Stratejik ve Kritik Madenler',
      'Enerji Kaynakları',
      'Sanayileşmenin Mekânsal Etkileri',
      'Gezegen Sınırı',
      'Küresel İklim Değişikliği',
      'Türkiye’de Suyun Sürdürülebilir Kullanımı',
      'Türkiye’nin Kültürel Hinterlandı',
      'Tarımsal Üretim: Örnek Ülke',
      'Sanayileşme Süreci: Örnek Ülkeler',
      'Madencilik Faaliyetleri: Örnek Ülke',
      'Enerji Kaynakları: Örnek Ülkeler',
    ],
    'Felsefe': [
      'Çevre ve İnsan İlişkisi',
      'Çevre Etiği',
      'Teknoloji ve İnsan Hayatı',
      'Teknoloji Bağlamında Ontolojik Problemler',
      'Teknoloji Bağlamında Aksiyolojik Problemler',
      'Akıl-İnanç İlişkisine Yönelik Felsefi Sorular ve Problemler',
      'Akıl-İnanç İlişkisine Yönelik Felsefi Görüş ve Argümanlar',
      'Edebiyat Felsefe İlişkisi',
      'Edebiyat Felsefe İlişkisi Problemleri',
      'Hayatın Anlamına Yönelik Felsefi Sorular ve Problemler',
      'Hayatın Anlamına Yönelik Felsefi Görüş ve Argümanlar',
      'Hukuk ve İnsan',
      'Hukukun Doğasına Yönelik Felsefi Problemler',
      'Hukukun Gereği ve Önemi, Hukukun Kaynağı, Ahlak-Hukuk İlişkisi',
    ],
    'Din Kültürü': [
      'İnsan ve Kader',
      'Akıl, İrade ve Sorumluluk Sahibi Bir Varlık Olarak İnsan',
      'Kur’an’dan Mesajlar (Kader ve İrade)',
      'Din, Felsefe ve Bilim',
      'Din ve Sanat',
      'Medeniyetin Oluşumu ve İslam Medeniyeti',
      'İslam Medeniyetinin Bugünü ve Geleceği',
      'İnançla İlgili Felsefi Yaklaşımlar & Kötülük Problemi',
      'Yeni Dinî Hareketler ve Din İstismarı',
      'Yahudilik ve Hristiyanlık',
    ],
  },

  MAARIF_10_SAYISAL: {
    'Matematik': [
      'Bir doğal sayının asal çarpanları ve bölenleri',
      'EBOB-EKOK',
      'Bölünebilme',
      'Karesel Fonksiyon',
      'Karekök Fonksiyonu',
      'Rasyonel Fonksiyonlar',
      'Bu fonksiyonların tersi',
      'Sayma Stratejileri',
      'Cebirsel ve Fonksiyonel İşlemlerin Algoritmik Yapısı',
      'Dik Üçgende Trigonometrik Oranlar ve Trigonometrik Özdeşlikler',
      'Üçgende iç ve dış açıortaylar, kenarortaylar, kenar orta dikme',
      'Üçgende Alan',
      'Sinüs ve Kosinüs Teoremleri',
      'Dik Koordinat Sisteminde Nokta ve Doğrunun Analitik İncelenmesi',
      'İki Nokta Arasındaki Uzaklık',
      'Bir Doğru Parçasını Belli Bir Oranda Bölme',
      'İki Kategorik Değişkenin İlişkililiğini İçeren İstatistiksel Problemi Oluşturma',
      'Verileri Toplama ve Analize Hazır Hâle Getirme',
      'Bulgulara Ulaşma ve Bulguları Yorumlama',
      'İstatistiksel Görsel, Özet, Sonuç, Yorum, Çıkarım veya Tahminleri Değerlendirme',
      'Koşullu Olasılık, Bağımlı ve Bağımsız Olaylar, Bayes Teoremi',
    ],
    'Fizik': [
      'Sabit Hızlı Hareket',
      'Bir Boyutta Sabit İvmeli Hareket',
      'Serbest Düşme',
      'İki Boyutta Sabit İvmeli Hareket',
      'İş, Enerji ve Güç',
      'Enerji Biçimleri',
      'Mekanik Enerji',
      'Enerji Kaynakları',
      'Basit Elektrik Devreleri',
      'Elektrik Akımı',
      'Ohm Yasası',
      'Dirençlerin Bağlanması',
      'Üreteçlerin Bağlanması',
      'Elektrik Akımının Oluşturabileceği Tehlikelere Karşı Alınması Gereken Önlemler',
      'Topraklamanın Önemi',
      'Dalgaların Temel Kavramları',
      'Dalgaların Sınıflandırılması',
      'Dalgaların Yayılma Süretini Etkileyen Etmenler',
      'Periyodik Hareketler',
      'Su Dalgalarında Yansıma ve Kırılma',
      'Rezonans ve Deprem',
    ],
    'Kimya': [
      'Kimyasal Tepkimeler',
      'Mol Kavramı',
      'Kimyasal Tepkime Denklemlerinin Denkleştirilmesi',
      'Kimyasal (Stokiyometrik) Hesaplamalar',
      'Gazlar, Gazların Özellikleri ve Gaz Yasaları',
      'Çözünme Süreci',
      'Maddelerin Birbiri İçindeki Çözünebilirliği',
      'Çözünme Olayının Sınıflandırılması',
      'Derişim Birimleri (Molarite, ppm)',
      'Çözünürlük',
      'Çözünürlüğe Etki Eden Faktörler',
      'Çözeltilerin Sınıflandırılması',
      'Kolloidal Özellikler',
      'Yeşil Kimya',
      'Çevresel ve Ekolojik Sürdürülebilirlik',
      'Makro ve Mikro Ölçekli Deneyler',
      'Atmosferdeki Tepkimeler ve Küresel Sorunlar',
    ],
    'Biyoloji': [
      'ATP\'nin Yapısı ve Enerji Aktarımında ATP\'nin Rolü',
      'Fotosentez',
      'Kemosentez',
      'Sindirim',
      'Hücresel Solunum',
      'Fermantasyon',
      'Enerji-Metabolizma İlişkisi',
      'Ekosistemin Bileşenleri',
      'Ekolojik Sürdürülebilirlik',
    ],
  },

  MAARIF_10_SOZEL: {
    'Türk Dili ve Edebiyatı': [
      'Giriş (Edebiyat Tarihi)',
      'Hikâye',
      'Şiir',
      'Tiyatro',
      'Roman',
      'Makale / Fıkra',
      'Deneme',
      'Eleştiri',
      'Söylev (Nutuk)',
      'Anı (Hatıra)',
      'Biyografi / Otobiyografi',
      'Gezi Yazısı',
      'Dil Bilgisi (Ses Bilgisi – Şekil Bilgisi – Söz Dizimi – Anlam Bilgisi)',
    ],
    'Tarih': [
      'Tarih ve Zaman',
      'İnsanlığın İlk Dönemleri',
      'Orta Çağ’da Dünya',
      'İslam Medeniyetinin Doğuşu',
      'Türklerin İslamiyeti Kabulü ve İlk Türk-İslam Devletleri',
      'Türkiye Tarihi',
      'Yüzyılda Avrupa ve Osmanlı Devleti',
      'Osmanlı Devleti’nde Kültür ve Medeniyet',
      'Osmanlı Devleti’nin Kuruluşu',
      'Değişen Dünya Dengeleri Karşısında Osmanlı Siyaseti (1595–1774)',
      'Sanayi İnkılabı ve Değişen Dünya',
    ],
    'Coğrafya': [
      'Coğrafyanın Konusu ve Bölümleri',
      'Harita Bilgisi',
      'Dünya’nın Şekli ve Hareketleri',
      'İklim Bilgisi',
      'Doğal Sistemler',
      'Nüfus ve Yerleşme',
      'Türkiye’nin Fiziki Coğrafyası',
      'Türkiye’nin Beşeri Coğrafyası',
      'Türkiye Ekonomisi',
      'Çevre ve Toplum',
    ],
    'Felsefe': [
      'Felsefeye Giriş ve Alanı',
      'Felsefenin Temel Problemleri',
      'Bilgi Felsefesi',
      'Varlık Felsefesi',
      'Ahlak Felsefesi',
      'Siyaset Felsefesi',
      'Sanat Felsefesi',
      'Din Felsefesi',
      'Bilim Felsefesi',
    ],
    'Psikoloji': [
      'Psikolojinin Bilim Olma Süreci',
      'Psikolojinin Temel Süreçleri',
      'Öğrenme, Bellek ve Düşünme',
      'Gelişim Psikolojisi',
      'Kişilik',
      'Psikolojik Bozukluklar',
      'Sosyal Psikoloji',
      'Uygulamalı Psikoloji',
    ],
    'Sosyoloji': [
      'Sosyolojiye Giriş',
      'Toplum ve Kültür',
      'Toplumsal Kurumlar',
      'Toplumsallaşma',
      'Toplumsal Tabakalaşma ve Eşitsizlik',
      'Gruplar ve Toplumsal Hareketler',
      'Kent ve Kentleşme',
      'Küreselleşme',
    ],
  },

  MAARIF_9_SAYISAL: {
    'Matematik': [
      'Gerçek sayıların üslü ve köklü gösterimleri ile yapılan işlemler',
      'Gerçek sayı aralıkları ile yapılan işlemler',
      'Sayı kümeleri ve işlem özellikleri',
      'İki kare farkı ve tamkare özdeşlikleri',
      'Doğrusal fonksiyon',
      'Mutlak değer fonksiyonu',
      'Doğrusal fonksiyonlarla ifade edilen denklem ve eşitsizlikler',
      'Algoritma temelli problemler, mantık bağlaçları ve niceleyiciler',
      'Üçgende açı ve kenarlarla ilgili özellikler',
      'Üçgende açı özellikleri arasındaki ilişkiler',
      'Üçgende kenar özellikleri arasındaki ilişkiler',
      'Geometrik dönüşümler',
      'Üçgende eşlik ve benzerlik',
      'Tales, Öklid ve Pisagor teoremleri',
      'Tek nicel değişken içeren istatistiksel problem oluşturma, verileri toplama ve analizle hazır hâle getirme, bulgulara ulaşma ve bulgulara yorumlama, istatistiksel görsel, özet, sonuç, yorum, çıkarım veya tahminleri değerlendirme',
      'Olayların olasılığını deneysel ve teorik olarak inceleme',
    ],
    'Biyoloji': [
      'Biyolojideki dönüşüm noktaları',
      'Bilimsel araştırma süreçleri',
      'Bilimsel araştırmaların bilim etiği',
      'Canlıların ortak özellikleri',
      'Canlıların sınıflandırılması',
      'Üç üst âlem (domain) sistemi',
      'Biyoçeşitlilik',
      'İnorganik moleküller',
      'Su, mineraller',
      'Organik moleküller',
      'Karbonhidratlar',
      'Yağlar',
      'Proteinler',
      'Enzimler',
      'Nükleik asitler',
      'Vitaminler',
      'Hücrenin yapısı',
    ],
    'Fizik': [
      'Fizik bilimi',
      'Fizik biliminin alt dalları',
      'Fizik bilimine yön verenler',
      'Fizik bilimi ile ilgili kariyer keşfi',
      'Temel ve türetilmiş nicelikler',
      'Skaler ve vektörel nicelikler',
      'Vektörler',
      'Doğadaki temel kuvvetler',
      'Hareket ve hareket türleri',
      'Basınç',
      'Kaldırma kuvveti',
      'Isı ve sıcaklık',
    ],
    'Kimya': [
      'Kimyasal maddelerin kullanımı ve güvenlik',
      'Kimyanın alt disiplinleri',
      'Kimya alanında kariyer olanakları',
      'Atom teorileri',
      'Atomun yapısı',
      'Periyodik tabloda yer bulma',
      'Periyodik özellikler',
      'Kimyasal türler arasında etkileşimler',
      'Bileşiklerin adlandırılması',
      'Katılar ve özellikleri',
      'Sıvılar ve özellikleri',
      'Nanoparçacıklar ve ekolojik sürdürülebilirlik',
      'Yeşil kimyanın atık önleme ilkesi',
    ],
  },
};

// Generates flat topic bank items with unique IDs for initial storage
export function generateCurriculumTopicBank() {
  const result = [];
  let counter = 1;

  Object.entries(STUDY_CURRICULUM_DATA).forEach(([groupKey, subjectMap]) => {
    let sinifName = 'YKS (Mezun)';
    if (groupKey === 'LGS') sinifName = '8. Sınıf (LGS)';
    else if (groupKey === 'SINIF_11_SAYISAL') sinifName = '11. Sınıf (Sayısal)';
    else if (groupKey === 'SINIF_11_EA') sinifName = '11. Sınıf (EA)';
    else if (groupKey === 'MAARIF_10_SAYISAL') sinifName = '10. Sınıf (Maarif Sayısal)';
    else if (groupKey === 'MAARIF_10_SOZEL') sinifName = '10. Sınıf (Maarif Sözel)';
    else if (groupKey === 'MAARIF_9_SAYISAL') sinifName = '9. Sınıf (Maarif Sayısal)';
    else if (groupKey === 'TYT') sinifName = 'TYT';
    else if (groupKey === 'AYT_SAYISAL') sinifName = 'AYT Sayısal';
    else if (groupKey === 'AYT_ESIT_AGIRLIK') sinifName = 'AYT Eşit Ağırlık';

    Object.entries(subjectMap).forEach(([subjectName, topicsList]) => {
      topicsList.forEach((topicName, idx) => {
        result.push({
          id: `curriculum-${groupKey.toLowerCase()}-${counter++}`,
          sinif: sinifName,
          ders: subjectName,
          donem: 'Genel',
          unite: `${subjectName} Konuları`,
          konu: topicName,
          sira: idx + 1,
          aktif: true,
        });
      });
    });
  });

  return result;
}

// Default presets for different grade levels and tracks
export const GRADE_LEVEL_CONFIGS = [
  { id: '11_sayisal', label: '11. Sınıf', track: 'Sayısal', groupKey: 'SINIF_11_SAYISAL', defaultDailyTarget: 80, weekendTarget: 120, defaultDailySessions: 4 },
  { id: '11_ea', label: '11. Sınıf', track: 'Eşit Ağırlık', groupKey: 'SINIF_11_EA', defaultDailyTarget: 80, weekendTarget: 120, defaultDailySessions: 4 },
  { id: '12_sayisal', label: '12. Sınıf', track: 'Sayısal', groupKey: 'AYT_SAYISAL', defaultDailyTarget: 100, weekendTarget: 150, defaultDailySessions: 5 },
  { id: '12_ea', label: '12. Sınıf', track: 'Eşit Ağırlık', groupKey: 'AYT_ESIT_AGIRLIK', defaultDailyTarget: 100, weekendTarget: 150, defaultDailySessions: 5 },
  { id: 'mezun_sayisal', label: 'Mezun / YKS', track: 'Sayısal', groupKey: 'AYT_SAYISAL', defaultDailyTarget: 120, weekendTarget: 180, defaultDailySessions: 5 },
  { id: 'mezun_ea', label: 'Mezun / YKS', track: 'Eşit Ağırlık', groupKey: 'AYT_ESIT_AGIRLIK', defaultDailyTarget: 120, weekendTarget: 180, defaultDailySessions: 5 },
  { id: '10_maarif_say', label: '10. Sınıf', track: 'Sayısal', groupKey: 'MAARIF_10_SAYISAL', defaultDailyTarget: 70, weekendTarget: 100, defaultDailySessions: 4 },
  { id: '10_maarif_soz', label: '10. Sınıf', track: 'Sözel / Sosyal', groupKey: 'MAARIF_10_SOZEL', defaultDailyTarget: 70, weekendTarget: 100, defaultDailySessions: 4 },
  { id: '9_maarif', label: '9. Sınıf', track: 'Sayısal', groupKey: 'MAARIF_9_SAYISAL', defaultDailyTarget: 60, weekendTarget: 90, defaultDailySessions: 4 },
  { id: 'lgs', label: '8. Sınıf (LGS)', track: 'LGS', groupKey: 'LGS', defaultDailyTarget: 90, weekendTarget: 140, defaultDailySessions: 4 },
];
